import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_aureate-preview/artifacts/h6n4fhlc_Only%20Logo.png';

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const PhoneSvg = () => (
  <svg viewBox="0 0 24 24"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" /></svg>
);
const MailSvg = () => (
  <svg viewBox="0 0 24 24"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 6L2 7" /></svg>
);
const PinSvg = () => (
  <svg viewBox="0 0 24 24"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" /><circle cx="12" cy="10" r="3" /></svg>
);
const LinkedInSvg = () => (
  <svg viewBox="0 0 24 24"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>
);
const WhatsAppSvg = () => (
  <svg viewBox="0 0 24 24"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22z" /></svg>
);

const Footer = () => {
  const quickLinks = [
    { label: 'Home', href: '#top' },
    { label: 'About', href: '#founder' },
    { label: 'Solutions', href: '#organisations' },
    { label: 'Our Approach', href: '#approach' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <footer className="site-footer" data-testid="footer">
      <div className="fwrap">
        <div className="ft">
          {/* Brand column */}
          <div>
            <div className="fbrand">
              <a className="flink" href="#top" aria-label="Aureate Residences home" onClick={(e) => { e.preventDefault(); scrollTo('#top'); }}>
                <img className="flogo" src={LOGO_URL} alt="Aureate Residences" />
              </a>
              <p className="tl">Accommodate<b>.</b> Operate<b>.</b> Manage<b>.</b></p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4>Quick Links</h4>
            <ul>
              {quickLinks.map(link => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4>Contact</h4>
            <div className="cl">
              <a href="tel:+447759342229" data-testid="footer-phone"><PhoneSvg />+44 7759 342229</a>
              <a href="mailto:info@aureate-resident.com" data-testid="footer-email"><MailSvg />info@aureate-resident.com</a>
              <span><PinSvg />United Kingdom</span>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4>Follow Us</h4>
            <div className="soc">
              <a href="https://linkedin.com/company/aureateresident" aria-label="LinkedIn" data-testid="footer-social-linkedin"><LinkedInSvg /></a>
              <a href="https://wa.me/447759342229" aria-label="WhatsApp" data-testid="footer-social-whatsapp"><WhatsAppSvg /></a>
            </div>
          </div>
        </div>

        {/* Legal bar */}
        <div className="legal">
          <p>&copy; 2026 Aureate Residences Ltd. All rights reserved. &middot; United Kingdom</p>
          <nav aria-label="Legal">
            <a href="/complaints">Complaints Procedure</a>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
